import { render, staticRenderFns } from "./empty-content.vue?vue&type=template&id=ec975016&scoped=true"
import script from "./empty-content.vue?vue&type=script&lang=js"
export * from "./empty-content.vue?vue&type=script&lang=js"
import style0 from "./empty-content.vue?vue&type=style&index=0&id=ec975016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec975016",
  null
  
)

export default component.exports